import SectionHeading from "./ui/SectionHeading";
import GradientButton from "./ui/GradientButton";
import Reveal from "./ui/Reveal";

const packages = [
  { title: "Hunza & Skardu", hotels: "3 & 4 star" },
  { title: "VIP Skardu", hotels: "3 & 4 star" },
  { title: "Honeymoon Package", hotels: "3 & 4 star" },
];

const accents = ["border-brand-orange", "border-brand-orange", "border-brand-gold"];

const Tourpackages = () => {
  return (
    <section id="packages" className="section-pad bg-[#eef5ea]">
      <SectionHeading
        eyebrow="Domestic Tours"
        title="Domestic Packages"
        subtitle="Explore the beauty of Pakistan with our curated domestic tour packages."
      />
      <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 sm:gap-8 md:grid-cols-3">
        {packages.map((pkg, i) => (
          <Reveal key={pkg.title} delay={i * 0.1}>
            <div
              className={`flex h-full flex-col rounded-2xl border-t-[3px] bg-white p-7 text-left shadow-soft transition-all duration-300 hover:-translate-y-2 ${accents[i]}`}
            >
              <h4 className="mb-1 text-xl font-bold text-brand-dark">{pkg.title}</h4>
              <p className="text-sm font-semibold text-brand-orange">Hotels {pkg.hotels}</p>
              <ul className="mt-4 space-y-2 text-sm text-gray-600">
                <li><span className="mr-1 text-brand-gold">✓</span> Flights Included</li>
                <li><span className="mr-1 text-brand-gold">✓</span> Hotel 3 &amp; 4 Star</li>
                <li><span className="mr-1 text-brand-gold">✓</span> Private Transport</li>
              </ul>
              <GradientButton variant="orange" href="#contact" className="mt-6 self-start">
                Book Now
              </GradientButton>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Tourpackages;
